import React from "react";
import YouTube from "react-youtube";
// import { Link } from 'gatsby';

import Layout from "../components/layout";
import SEO from "../components/seo";

import ImagesStripLeisure from "../components/ImagesStripLeisure";

import {
  Card,
  CardHeader,
  CardBody,
  // Button,
  CardTitle,
  CardText
  // CardImg
} from "reactstrap";

import DartfordCarousel from "../components/dartfordCarousel";
import NewportCarousel from "../components/newportCarousel";
import NavanCarousel from "../components/navanCarousel";
import HerneCarousel from "../components/herneCarousel";

const LeisurePage = () => (
  <Layout>
    <SEO title="Leisure" />
    <div className="container">
      <h1 className="d-block text-center display-3">Leisure</h1>
      <div className="d-block text-center mt-3">
        <p className="lead">
          Pubs, Clubs, Gyms, Hotels and all others in between. One off bespoke
          projects or repeat multiple sites, we are flexible enough to adapt to
          your needs and deliver your projects with a minimum of fuss.
        </p>
      </div>
      <ImagesStripLeisure />

      <hr />
      <div id="projects">
        <h3 className="d-block text-center">Recent Leisure Projects</h3>

        <Card className="m-5">
          <CardHeader>Snap Fitness - Herne Bay</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Fit out of an ex retail space to form a brand new 10,000 sq ft
                Snap Fitness Gymnasium
              </strong>
            </CardTitle>
            <CardText>
              CURRENTLY IN PROGRESS ONSITE! <br />
              <br />
              Coming Soon - Watch this space for updates!!
            </CardText>
            <CardText>
              <small className="text-muted">Updated 29.01.20</small>
            </CardText>
          </CardBody>
          <div className="mx-4 mb-4">
            <HerneCarousel />
          </div>
        </Card>

        <Card className="m-5">
          <CardHeader>Snap Fitness - Navan - Ireland</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Fit out of shopping centre retail unit to form a new Snap
                Fitness Gym
              </strong>
            </CardTitle>
            <CardText>
              This project was a fit out of a developer shell to form a new Snap
              Fitness Gymnasium. <br />
              <br />
              Works included partitioning, joinery, ceilings, specialist
              flooring, formation of changing and shower areas, complete M&E and
              specialist electrical packages.
            </CardText>
            <CardText>
              <small className="text-muted">Updated 27.01.20</small>
            </CardText>
          </CardBody>
          <div className="mx-4 mb-4">
            <NavanCarousel />
          </div>
        </Card>

        <Card className="m-5">
          <CardHeader>Snap Fitness - Isle of Wight - Newport</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Fit out of an existing Matressman Unit to form a new Snap
                Fitness Gym
              </strong>
            </CardTitle>
            <CardText>
              This project was a fit out of a developer stripped out retail unit
              to form a new Snap Fitness Gymnasium. <br />
              <br />
              Works include installation of a new full cover mezzanine floor,
              partitioning, new entrance lobby, joinery, ceilings, specialist
              flooring, formation of changing and shower areas and complete M&E
              installations.
            </CardText>
            <CardText>
              <small className="text-muted">Updated 19.05.19</small>
            </CardText>
          </CardBody>
          <div className="mx-4 mb-4">
            <NewportCarousel />
          </div>
        </Card>

        <Card className="m-5">
          <CardHeader>Snap Fitness - Dartford</CardHeader>
          <CardBody>
            <CardTitle>
              <strong>
                Fit out of a newly built developer shell to form a new Snap
                Fitness gym
              </strong>
            </CardTitle>
            <CardText>
              Our first project for Snap Fitness and very well recieved. The
              project was a fit out of a new build mixed use unit to form a new
              Snap Fitness gymnasium. <br />
              <br />
              Works included extensive accoustic works, partitioning, joinery,
              ceilings, specialist flooring, formation of changing and shower
              areas and complete M&E installations.
            </CardText>
            <CardText>
              <small className="text-muted">Updated 10.07.19</small>
            </CardText>
            <br />
            <div className="mx-4 mb-4">
              <DartfordCarousel />
            </div>
            <div className="d-block text-center">
              <h6>Check out the video fly through below</h6>
            </div>
            <div className="m-4">
              <div className="embed-responsive embed-responsive-16by9">
                <YouTube
                  className="embed-responsive-item"
                  videoId="O2ADCnY2QNY"
                  opts={{
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      iv_load_policy: 3,
                      rel: 0,
                      modestbranding: 1
                    }
                  }}
                  // onReady={this._onReady}
                />
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  </Layout>
);

export default LeisurePage;
